import { v4 as uuidv4 } from 'uuid';

export function getFileName(extension: string = 'png', prefix?: string): string {
  const now = new Date();

  // 한국 시간 기준 문자열 예: 20250813_143012
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');

  const dateStr = `${y}${m}${d}_${hh}${mm}${ss}`;
  const id = uuidv4();

  if (prefix) {
    return `${prefix}_${dateStr}_${id}.${extension}`;
  }

  return `${dateStr}_${id}.${extension}`;
}
